/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보 결과 추가 버튼 컴포넌트
 * 버전 : 1.0
 * 파일명 : ButtonResultAdd.ts
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-17, 강동형 : 저작권 추가, 토스트 팝업 로직 위치 변경, 참여자수>전체학생 수 유효성 검사 로직 추가
 * ================================================================ 
 */

import React from 'react'
import { NextButton } from '../common/CommonStyled'
import { usePromoresultStore } from 'src/stores/PromoStore'
import { postPromotion } from 'src/api/Promo'
import { format } from 'date-fns'
import { PromoResultType } from 'src/pages/PromoResultPage';
import { useDialogStore } from 'src/stores/DialogStore'

interface Props{
  setTab : React.Dispatch<React.SetStateAction<PromoResultType>>;
}

const ButtonResultAdd = ({setTab}:Props) => {
    const visited_date = usePromoresultStore((state)=>state.visit_date)
    const school_id = usePromoresultStore((state)=>state.school_id)
    const total_count = usePromoresultStore((state)=>state.total_cnt)
    const attendee_cnt = usePromoresultStore((state)=>state.attendee_cnt)
    const interested_cnt = usePromoresultStore((state)=>state.interested_cnt)
    const apply_cnt = usePromoresultStore((state)=>state.apply_cnt)
    const content = usePromoresultStore((state)=>state.content)
    const school_class = usePromoresultStore((state)=>state.school_class)
    const setField = useDialogStore((state)=>state.setField)

    const isAttendeeValid = (Number(total_count)>=Number(attendee_cnt)) ? true:false
  
  const isDisabled =
    !visited_date ||
    !school_id ||
    !total_count ||
    !attendee_cnt ||
    !isAttendeeValid;

    const handleResultAdd = async()=>{
        const fromat_date = format(visited_date, 'yyyy-MM-dd');
        await postPromotion(
            {visit_date : fromat_date,
            school_id: school_id,
            school_class: school_class,
            total_cnt: total_count,
            attendee_cnt: attendee_cnt,
            interested_cnt : interested_cnt,
            apply_cnt : apply_cnt,
            content: content
        })

        setField('response_data',[])
        setField('page_Num',1)
        setTab('home')
    }

  return (
    <NextButton onClick={()=>handleResultAdd()} disabled={isDisabled}>적용</NextButton>
  )
}

export default ButtonResultAdd